import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';

import { IonicModule } from '@ionic/angular';

import { ReportPointRedeemPageRoutingModule } from './report-point-redeem-routing.module';

import { ReportPointRedeemPage } from './report-point-redeem.page';
import { IonicSelectableModule } from 'ionic-selectable';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    IonicModule,
    ReportPointRedeemPageRoutingModule,
    IonicSelectableModule
  ],
  declarations: [ReportPointRedeemPage]
})
export class ReportPointRedeemPageModule {}
